var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBedIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 11.3334V6.00002C1 5.6464 1.14048 5.30726 1.39052 5.05721C1.64057 4.80716 1.97971 4.66669 2.33333 4.66669M2.33333 4.66669H11.6667M2.33333 4.66669V2.00002C2.33333 1.6464 2.47381 1.30726 2.72386 1.05721C2.97391 0.807163 3.31304 0.666687 3.66667 0.666687H10.3333C10.687 0.666687 11.0261 0.807163 11.2761 1.05721C11.5262 1.30726 11.6667 1.6464 11.6667 2.00002V4.66669M11.6667 4.66669C12.0203 4.66669 12.3594 4.80716 12.6095 5.05721C12.8595 5.30726 13 5.6464 13 6.00002V11.3334M1 10H13",
    stroke: "#18181B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedIcon1);
export default __webpack_public_path__ + "static/media/bed-icon-1.b2940195f02bc08e8c09255c85cffdcc.svg";
export { ForwardRef as ReactComponent };